import { REQUEST } from 'Stores'
import {
  CHANGE_TO_TEAM_PLAN,
  CHANGE_TO_REGISTER_PLAN,
  GET_PLAN,
  CHANGE_TO_BASIC
} from './constants'

export function getPlan() {
  return {
    type: REQUEST(GET_PLAN)
  }
}

export function changeTeamPlan(payload) {
  return {
    type: REQUEST(CHANGE_TO_TEAM_PLAN),
    payload
  }
}

export function changeRegisterPlan(payload) {
  return {
    type: REQUEST(CHANGE_TO_REGISTER_PLAN),
    payload
  }
}

export function changeBasic() {
  return {
    type: REQUEST(CHANGE_TO_BASIC)
  }
}
